export function SidebarFooter() {
  return (
    <div className="px-2 py-2 text-[10px] text-muted-foreground/50 text-center">
      Crafted with ❤️ by VyralSearch
    </div>
  );
}